import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import rp, { AppComponent, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { AdminBrowserAdapter } from "../adapters";

@customElement('rp-admin-sidebar')
export class Sidebar extends AppComponent {

	static styles = [style];

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: AdminBrowserAdapter;
    get browserAdapter() { 
        if (!this._browserAdapter) {
            this._browserAdapter = new AdminBrowserAdapter();
        }
        return this._browserAdapter;
    }

	refresh = () => {
		this.browser.refresh();
	}

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.adminBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			adminBrowser: this.browser?.getState(),
		}
	}

	_onChangeState = () => {
		this.dispatchStateEvent();
	}

	_onSelect = (e: BrowserEvent) => {
		if (e.node.key.includes('Form')) {
			rp.host.openModalSidebar({id: e.node.key, caption: e.node.value});
		} else {
			rp.host.open(e.node.key, {title: e.node.value});
		}
	}

	render = () => html`
		<div class="body">
			<rp-browser id="browser" .adapter="${this.browserAdapter}" @browser.select="${this._onSelect}"></rp-browser>
		</div>
	`;

}
